export default function setTitle(params, defaultTitle) {
    const { company_name, white_label, } = params;
    if ((white_label === 'LOW' || white_label === 'HIGH') && company_name) {
        document.title = company_name;
        return;
    }
    document.title = defaultTitle;
}
